import React, { useEffect, useState } from 'react';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import { get } from 'lodash';

import { refreshReloadPrompt } from 'hooks';
import PageTemplate from 'components/general/PageTemplate';
import { getStaff } from 'api/staff';
import Staff from './Staff';
import {
  columns,
  suggestionPrimaryKey,
  suggestionSecondaryKeys,
} from './staff.config';

const Services = () => {
  const { path } = useRouteMatch();
  const history = useHistory();

  const [modalOpen, setModalOpen] = useState(true);
  const [staff, setStaff] = useState();
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [loading, setLoading] = useState(false);
  const [blockRouteChange, setBlockRouteChange] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  const fetchStaff = async () => {
    const { data } = await getStaff(pageNumber, pageSize);

    setStaff(data);
    setRowCount(data.pagination.total);
  };

  useEffect(async () => {
    setLoading(true);

    await fetchStaff();
    setLoading(false);
  }, [pageNumber, pageSize]);

  const handleModalOpen = ({ id }) => {
    history.push(`/staff/${id}`);
    setModalOpen(true);
  };

  const handleModalClose = async (save) => {
    if (save && typeof save === 'boolean') {
      history.block(() => true);
      setModalOpen(false);
    }

    if (!blockRouteChange && !save && typeof save !== 'boolean') {
      setModalOpen(false);
    }

    history.push('/staff');
    await fetchStaff();
    window.removeEventListener('beforeunload', refreshReloadPrompt);
  };

  const handleAdd = async () => {
    history.push('/staff/add');
    setModalOpen(true);
    await fetchStaff();
  };

  return (
    <>
      <PageTemplate
        data={get(staff, 'data', [])}
        columns={columns}
        suggestionPrimaryKey={suggestionPrimaryKey}
        suggestionSecondaryKeys={suggestionSecondaryKeys}
        handleModalOpen={handleModalOpen}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
        rowCount={rowCount}
        pageNumber={pageNumber}
        pageSize={pageSize}
        loading={loading}
        handleAdd={handleAdd}
        setModalOpen={setModalOpen}
      />

      <Switch>
        <Route path={`${path}/add`}>
          <Staff
            modalOpen={modalOpen}
            handleModalClose={handleModalClose}
            blockRouteChange={blockRouteChange}
            setBlockRouteChange={setBlockRouteChange}
          />
        </Route>

        <Route path={`${path}/:id`}>
          <Staff
            modalOpen={modalOpen}
            handleModalClose={handleModalClose}
            blockRouteChange={blockRouteChange}
            setBlockRouteChange={setBlockRouteChange}
          />
        </Route>
      </Switch>
    </>
  );
};
export default Services;
